import React from "react";

function XeerEthereum() {
  return (
    <>
      <div className="award-style-one-area default-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="site-heading text-center">
                <h4 className="sub-title">Achivement &amp; Awards</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Xeer's Ethereum Blockchain Development Services
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="award-style-one-items">
                <div className="award-style-one-item hover-active-item">
                  <div className="image-wrapper">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/brand/1.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="title">
                    <h4>Ethereum DApp Development</h4>
                  </div>
                  <div className="info">
                    <p>
                      We build decentralized applications on Ethereum that are
                      scalable, secure, and provide a seamless user experience
                      for various industries, from finance to supply chain.
                    </p>
                  </div>
                  <div className="year">
                    <h2>01</h2>
                  </div>
                </div>

                <div className="award-style-one-item hover-active-item">
                  <div className="image-wrapper">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/brand/2.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="title">
                    <h4>Ethereum DeFi Development</h4>
                  </div>
                  <div className="info">
                    <p>
                      Our team develops Ethereum-based DeFi solutions such as
                      lending protocols, decentralized exchanges, and yield
                      farming platforms, empowering your business to leverage
                      DeFi's potential.
                    </p>
                  </div>
                  <div className="year">
                    <h2>02</h2>
                  </div>
                </div>

                <div className="award-style-one-item hover-active-item">
                  <div className="image-wrapper">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/brand/3.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="title">
                    <h4>Smart Contract Development</h4>
                  </div>
                  <div className="info">
                    <p>
                      Xeer creates secure, efficient smart contracts using
                      Solidity for the Ethereum network, ensuring that your
                      business operations are automated and safe from
                      vulnerabilities.
                    </p>
                  </div>
                  <div className="year">
                    <h2>03</h2>
                  </div>
                </div>

                <div className="award-style-one-item hover-active-item">
                  <div className="image-wrapper">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/brand/4.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="title">
                    <h4>NFT Marketplace Development</h4>
                  </div>
                  <div className="info">
                    <p>
                      We design and deploy feature-rich NFT marketplaces on
                      Ethereum, providing support for minting, trading, and
                      managing digital assets with ease and reliability.
                    </p>
                  </div>
                  <div className="year">
                    <h2>04</h2>
                  </div>
                </div>
                <div className="award-style-one-item hover-active-item">
                  <div className="image-wrapper">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/brand/1.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="title">
                    <h4>Ethereum Wallet Development</h4>
                  </div>
                  <div className="info">
                    <p>
                      Developing secure, intuitive wallets for Ethereum, we
                      enable users to store, manage, and transact ETH and ERC-20
                      tokens with ease and security.
                    </p>
                  </div>
                  <div className="year">
                    <h2>05</h2>
                  </div>
                </div>
                <div className="award-style-one-item hover-active-item">
                  <div className="image-wrapper">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/brand/1.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="title">
                    <h4>Token Development (ERC-20, ERC-721, ERC-1155)</h4>
                  </div>
                  <div className="info">
                    <p>
                      Our expertise includes creating various Ethereum tokens
                      tailored to your specific business needs, from fungible
                      tokens (ERC-20) to non-fungible tokens (ERC-721) and
                      multi-token standards (ERC-1155).
                    </p>
                  </div>
                  <div className="year">
                    <h2>06</h2>
                  </div>
                </div>
                <div className="award-style-one-item hover-active-item">
                  <div className="image-wrapper">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/brand/1.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="title">
                    <h4>Blockchain Integration Services</h4>
                  </div>
                  <div className="info">
                    <p>
                      We help businesses integrate Ethereum with their existing
                      systems, ensuring smooth blockchain adoption for enhanced
                      transparency and efficiency.
                    </p>
                  </div>
                  <div className="year">
                    <h2>07</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default XeerEthereum;
